'use strict';
var parent = require('../../es/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/array/from.js
// module id = 489
// module chunks = 0